module.exports = __webpack_public_path__ + "img/22.8e5d4e8b.jpg";